import type { AgentId } from "./nav.js";

/**
 * Public social profiles for each desk persona — Apple Music “artist” links.
 * Placeholder firm handles for now; swap for real profile URLs when live.
 */
export type AgentSocials = {
	linkedinUrl: string | null;
	xUrl: string | null;
};

const SOCIALS: Record<AgentId, AgentSocials> = {
	onboarding: {
		linkedinUrl: "https://www.linkedin.com/in/mairko-jules",
		xUrl: "https://x.com/mairkojules",
	},
	paid_media: {
		linkedinUrl: "https://www.linkedin.com/in/mairko-miles",
		xUrl: "https://x.com/mairkomiles",
	},
	ga4_anomaly: {
		linkedinUrl: "https://www.linkedin.com/in/mairko-nadia",
		xUrl: "https://x.com/mairkonadia",
	},
	seo: {
		linkedinUrl: "https://www.linkedin.com/in/mairko-theo",
		xUrl: "https://x.com/mairkotheo",
	},
	content: {
		linkedinUrl: "https://www.linkedin.com/in/mairko-iris",
		xUrl: "https://x.com/mairkoiris",
	},
	social: {
		linkedinUrl: "https://www.linkedin.com/in/mairko-sol",
		xUrl: "https://x.com/mairkosol",
	},
	email: {
		linkedinUrl: "https://www.linkedin.com/in/mairko-vera",
		xUrl: "https://x.com/mairkovera",
	},
	creative: {
		linkedinUrl: "https://www.linkedin.com/in/mairko-kai",
		xUrl: "https://x.com/mairkokai",
	},
	cro: {
		linkedinUrl: "https://www.linkedin.com/in/mairko-quinn",
		xUrl: "https://x.com/mairkoquinn",
	},
	local: {
		linkedinUrl: "https://www.linkedin.com/in/mairko-dana",
		xUrl: "https://x.com/mairkodana",
	},
	developer: {
		linkedinUrl: "https://www.linkedin.com/in/mairko-rhea",
		xUrl: "https://x.com/mairkorhea",
	},
	reporting: {
		linkedinUrl: "https://www.linkedin.com/in/mairko-arlo",
		xUrl: "https://x.com/mairkoarlo",
	},
};

export function socialsFor(agentId: AgentId): AgentSocials {
	return SOCIALS[agentId];
}
